import { render } from "./Trash.vue?vue&type=template&id=486aa943"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__